export const EMAIL_SENT: string = 'Your email was sent.';
export const LINK_COPIED: string = 'Link copied to clipboard.';
export const DOCUMENT_SAVED: string = 'Document saved.';
export const DOCUMENT_UNSAVED: string = 'Document no longer saved.';
export const REPORT_ISSUE_SENT: string = 'Thank you for your email.';
export const CITE_COPIED: string = 'Cite copied to clipboard.';
export const DOCUMENT_UNSAVED_ERROR: string = 'An error was encountered. The document might not of been unsaved.';
export const ERROR_NOTIFICATION: string = 'Sorry, an error was encountered.';
